import { Observable } from 'rxjs';
import { UserEgiApp } from '@/app/platform/platform-core/user/models/user-egi-app';
import { UserNavigationItem } from '@/app/platform/platform-core/user/models/user-navigation-item';
import { InjectionToken } from '@angular/core';

export const ACTIVE_APP_QUERIES = new InjectionToken<ActiveAppQueries>('');

export interface ActiveAppQueries {
  readonly activeApp$: Observable<UserEgiApp | undefined>;

  getActiveApp(): UserEgiApp | undefined;

  readonly activeNavigationItem$: Observable<UserNavigationItem | undefined>;

  getActiveNavigationItem(): UserNavigationItem | undefined;
}
